<template>
    <LoginDialog @close="close" :withoutClose="withoutClose" class="flex flex-col">
        <div class="login-cn px-10 pb-6 flex-1 flex flex-col ">
            <WujieVue class="flex-1 mb-6 flex flex-col" v-bind="wujieOptions" :plugins="wujiePlugins"/>
        </div>
    </LoginDialog>
</template>

<script setup lang="ts">
import '@patsnap-ui/icon/assets/solid/DoubleArrowDown.svg'
import '@patsnap-ui/icon/assets/solid/DoubleArrowUp.svg'
import LoginDialog from './LoginDialog.vue';
import WujieVue from 'wujie-vue3';
import { buildQueryChannels, WUJIE_PROPS_USER_ENTRY_METHOD } from '..';
import type { Channels } from '..';
import type { InitFormParams } from './login-us/types/accounts';

const props = defineProps<{
    channels: Channels,
    withoutClose?: boolean,
    initFormParams?: InitFormParams,
}>()

const emits = defineEmits<{
    (e: 'success', data: { [key: string]: string }): void;
    (e: 'failed', error: Error): void;
    (e: 'close'): void;
}>();

/**
* 处理跳转到忘记密码页面
*/
function isForgetPassword(url: string) {
    const forgetPsdLabel = 'forgetPassword'
    return url.includes(forgetPsdLabel)
}

// 获取 account URL，支持 fallback
const getAccountUri = () => {
    const envUri = import.meta.env.VITE_ACCOUNT_URI
    console.log('[LoginCN] VITE_ACCOUNT_URI:', envUri)
    // 如果环境变量有效（不是占位符、不是本地代理路径），使用它
    if (envUri &&
        !envUri.includes('{{') &&
        envUri !== 'undefined' &&
        !envUri.startsWith('/proxy-') &&
        envUri.startsWith('http')) {
        return envUri
    }
    // 否则根据当前域名推断
    const hostname = window.location.hostname
    console.log('[LoginCN] hostname:', hostname)
    // 匹配 qa-eureka.zhihuiya.com, stage-eureka.zhihuiya.com 等
    const match = hostname.match(/^(qa-|stage-)?eureka\.zhihuiya\.com$/)
    const prefix = match?.[1] || '' // 'qa-', 'stage-', 或 ''
    const fallback = `https://${prefix}account.zhihuiya.com`
    console.log('[LoginCN] Using fallback:', fallback)
    return fallback
}

// URL 格式：https://account.zhihuiya.com?from=eureka&...#/sub-login（不需要 /login/ 路径）
const loginUrl = `${getAccountUri()}?${buildQueryChannels(props.channels)}#/sub-login`
console.log('[LoginCN] WujieVue URL:', loginUrl)

const wujieOptions = {
    name: 'eureka:air-login',
    url: loginUrl,
    props: {
        jumpTo: (url: string) => {
            if (isForgetPassword(url)) {
                window.location.replace(url)
                return
            }
            emits('success', { url })
        },
        // 支持三种登录方式：微信扫码、账号密码、手机验证
        userEntryMethods: [
            WUJIE_PROPS_USER_ENTRY_METHOD.Wechat,
            WUJIE_PROPS_USER_ENTRY_METHOD.Account,
            WUJIE_PROPS_USER_ENTRY_METHOD.SMS
        ],
        loginFormParams: props.initFormParams,
    },
}

const wujiePlugins = [
    {
        cssAfterLoaders: [
            { content: '.idps-suggestion{left:0!important;}' }
        ],
    }
]

// const otherLoginTypeUrl = new Site({ sld: SLD.ACCOUNT, pathname: `?redirect_uri=${encodeURIComponent(window.location.href)}&${buildQueryChannels(props.channels)}#/eureka-login` }).href

function close() {
    emits('close')
}

</script>
